// 비빌번호 재설정

import { useMutation } from "@tanstack/react-query";
import { resetPwdInfCheckApi } from "components/api/member";
import { apifield } from "components/utils/comm";
import i18n from "locales/i18n";
import { useTranslation } from "react-i18next";
import useAlertStore from "store/alert";
import { useBaseResetPwdParamContext } from "./context";

export const useBaseCheckInfMutate = () => {
  const { t } = useTranslation();
  const { onReset } = useBaseResetPwdParamContext();
  const onSetAler = useAlertStore((state) => state.onSetAlert);

  return useMutation({
    mutationKey: ["rest-pwd-base"],
    mutationFn: resetPwdInfCheckApi,
    onSuccess: (res) => {
      if (res) {
        const {
          status: { code, message },
        } = res;
        if (code === 0) {
          // 성공
          onSetAler({
            isOpen: true,
            inner: t("alt_auth_eml_done"),
            onSetConfirm: () => {
              onReset();
            },
          });
        }
        if (code === -1) {
          apifield(message);
        }
      }
    },
  });
};
